// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/tablehistory.scss
// module id = 391
// module chunks = 2